import { FC } from 'react';
import { Field } from 'react-final-form';
import { required } from '../../helpers';
import FormError from '../Common/FormError';
import LocationWithAddress from '../Common/LocationWithAddress';

type Props = {
  readOnly?: boolean;
  businessCountryId?: number;
};

const BorrowerBusiness: FC<Props> = ({ readOnly, businessCountryId }) => {
  return (
    <>
      <div className='mb-5 col-lg-12'>
        <Field name='business_name' type='text' validate={readOnly ? undefined : (v) => required(v, 'Employer Name')}>
          {({ input, meta }) => (
            <>
              <label className='form-label'>What is the Name of Company?</label>
              <div className='mb-3'>
                <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly={readOnly} />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <LocationWithAddress label='Company Location' cityFormName='business_city' stateFormName='business_state' countryFormName='business_country' countryId={businessCountryId} />

      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <label className='form-label'>What's Your Company RC Number?</label>
          <Field name='rc_no' type='text' validate={readOnly ? undefined : (v) => required(v, 'Job Title')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly={readOnly} />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>

        <div className='mb-5 col-lg-6'>
          <label className='form-label'>What's Your Job Title/Position?</label>
          <Field name='job_title' type='text' validate={readOnly ? undefined : (v) => required(v, 'Job Title')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='text' {...input} className='form-control form-control-lg form-control-solid' readOnly={readOnly} />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>

      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <label className='form-label'>What's The Nature of Your Business?</label>
          <Field name='business_type' type='text' validate={readOnly ? undefined : (v) => required(v, 'Business Type')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='text' placeholder='Business Type' {...input} className='form-control form-control-lg form-control-solid' readOnly={readOnly} />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>

        <div className='mb-5 col-lg-6'>
          <label className='form-label'>How Long Have You Been in Operation</label>
          <Field name='business_duration' type='text' validate={readOnly ? undefined : (v) => required(v, 'Duration')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='number' placeholder='in years' {...input} className='form-control form-control-lg form-control-solid' readOnly={readOnly} />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>
    </>
  );
};

export default BorrowerBusiness;
